import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [
    'tasksApdus',
    'taskMiners',
    'taskTickets',
    'tasksNetwork',
    'buyHostHostingPrices',
    'buyHostOrders',
    'minerHostingPrices',
    'minerHostingTypes',
    'minerHostingOrders',
    'minerHostingMinerReturn',
    'cloudMiningOrders'
  ]
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    removeNotification: (state, action) => {
      const { pageName } = action.payload;
      const updatedNotifications = state.notifications.filter(
        notification => notification !== pageName
      );
      state.notifications = updatedNotifications;
    }
  }
});

export const { removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
